import { saveNavigationData } from "@redux/slices/navigationMenuSlice";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import {
  setNavigationCustomisationLoad,
  setOrgNavigationCustomisation,
} from "@redux/slices/appStateSlice";
import { ThemeTokenTypes } from "@scenes/splash-screen/types";

export const useNavigationMenu = (
  url: string,
  enabled: boolean,
  type?: string
) => {
  const dispatch = useDispatch();
  const timestamp = Date.now();

  return useQuery({
    queryKey: ["NAVIGATION_MENU"],
    enabled,
    queryFn: () =>
      axios.get(url + "?timestamp=" + timestamp).then((data) => {
        if (type === ThemeTokenTypes.ORG) {
          dispatch(setOrgNavigationCustomisation(data.data));
        }
        if (type === ThemeTokenTypes.COMPANY)
          dispatch(setNavigationCustomisationLoad(true));
        if (data?.data?.sections) {
          dispatch(saveNavigationData(data.data));
        }
        return data;
      }),
    onError: (err) => {
      console.log("err", err);
    },
  });
};
